export enum BuilderType {
    EShop = "EShop",
    UserPreview = "UserPreview"
}


export enum OrigBuilderType {
    Builder = "builder",
    UserPreview = "userPreview"
}